import React, {PureComponent} from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { createPopper } from '@popperjs/core';
import OutsideClickHandler from 'react-outside-click-handler';

class Popover extends PureComponent {
  static defaultProps = {
    position: 'bottom-start',
    offsetX: 0,
    offsetY: 0
  };

  ref = React.createRef();

  componentDidMount() {
    const {open} = this.props;

    if (open) {
      this.openPopper();
    }
  }

  componentWillUnmount() {
    const {open} = this.props;

    if (open) {
      this.closePopper();
    }
  }

  componentDidUpdate(prevProps) {
    const {open} = this.props;

    if (!prevProps.open && open) {
      this.openPopper();
    }
    else if(prevProps.open && !open) {
      this.closePopper();
    }
  }

  openPopper = () => {
    const {relativeTo, position, offsetX, offsetY} = this.props;
    const target = document.getElementById(relativeTo);

    this.popper = createPopper(target, this.ref.current, {
      placement: position,
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: ({ placement, reference, popper }) => {
              if (offsetX !== 0 || offsetY !== 0) {
                return [offsetX, offsetY];
              }
              else {
                return [];
              }
            }
          }
        }
      ]
    });
  }

  closePopper = () => {
    this.popper.destroy();
    this.popper = null;
  }

  handleRequestClose = e => {
    const {onClose, relativeTo} = this.props;
    const target = document.getElementById(relativeTo);

    if (target.contains(e.target)) {
      // Prevents firing toggle actions twice.
      return;
    }
    
    onClose(e);
  }

  scheduleUpdate = () => this.popper.update();

  getContainer = () => {
    return this.ref.current;
  }

  render() {
    const {open, relativeTo, offsetX, offsetY, width, fullWidth, ...props} = this.props;
    const target = document.getElementById(relativeTo);
    const children = React.Children.map(this.props.children, child => {
      if (child && typeof child.type === 'object') {
        return React.cloneElement(child, {
          closeMenu: this.handleRequestClose
        });
      }

      return child;
    });

    if (!open) {
      return null;
    }

    return ReactDOM.createPortal(
      <Container {...props} width={width || (fullWidth ? `${target.offsetWidth}px` : 'auto')} ref={this.ref}>
        <OutsideClickHandler onOutsideClick={this.handleRequestClose}>
          {children}
        </OutsideClickHandler>
      </Container>,
      document.getElementById('popover-root')
    );
  }
}

const Container = styled.div`
  width: ${props => props.width};
  z-index: 30;
`;

export default Popover;